import Vue from "vue";
import {
  isRegionScope,
  resolveWeiShopApi,
} from "@/views/apps/weishop/region/utils/regionApiMap";

const request = () => Vue.prototype.axios;
const api = (url) => resolveWeiShopApi(url);

const adminIndexUrl = "/api/weishop/admin/wechat-merchant-bindings";
const adminCandidatesUrl = "/api/weishop/admin/wechat-merchant-bindings/candidates";

const storeIndexUrl = "/api/weishop/store/store/wechat-merchant-binding";
const storeCandidatesUrl = "/api/weishop/store/store/wechat-merchant-binding/candidates";
const storeEnableUrl = "/api/weishop/store/store/wechat-merchant-binding/enable";

function currentRegionStoreId() {
  return sessionStorage.getItem("currentRegionStoreId") || "";
}

function withStoreParams(params) {
  if (!isRegionScope()) return params || {};
  const storeId = currentRegionStoreId();
  return storeId ? Object.assign({}, params || {}, { store_id: storeId }) : (params || {});
}

function withStorePayload(data) {
  if (!isRegionScope()) return data || {};
  const storeId = currentRegionStoreId();
  return storeId ? Object.assign({}, data || {}, { store_id: storeId }) : (data || {});
}

export const listMerchantBindings = (params) =>
  request().get(api(adminIndexUrl), { params });
export const listMerchantBindingCandidates = (params) =>
  request().get(api(adminCandidatesUrl), { params });
export const saveMerchantBinding = (data) =>
  request().post(api(adminIndexUrl), data);
export const enableMerchantBinding = (id) =>
  request().post(api(`${adminIndexUrl}/${id}/enable`));
export const disableMerchantBinding = (id) =>
  request().post(api(`${adminIndexUrl}/${id}/disable`));

export const getStoreMerchantBinding = (params) =>
  request().get(api(storeIndexUrl), { params: withStoreParams(params) });
export const listStoreMerchantBindingCandidates = (params) =>
  request().get(api(storeCandidatesUrl), { params: withStoreParams(params) });
export const enableStoreMerchantBinding = (data) =>
  request().post(api(storeEnableUrl), withStorePayload(data));
